// extracted by mini-css-extract-plugin
export default {"contactSellerWrapper":"_63819e70","soldBy":"_2f46b7ed","contactSellerBtn":"_8703055b","contactSupportInfo":"_6b04d963","contactSupportLink":"_13269d4d"};